exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-box span[data-v-6d0c6156]{margin-right:6px}.flex-box span[data-v-6d0c6156]:last-of-type{margin-right:0}.category_id .el-cascader[data-v-6d0c6156]{min-width:310px !important}.category_id .el-cascader[data-v-6d0c6156] .el-input__suffix{z-index:20}.select-bar[data-v-6d0c6156]{height:33px !important}[data-v-6d0c6156] .el-cascader__tags{position:absolute;right:0}\n", ""]);

// exports
